import ApprovedApplications from "../Administration/ApprovedApplications";

const FireApprovedPermissions = ({ role }) => {
  return (
    <>
      <ApprovedApplications role={role} />
    </>
  );
};

export default FireApprovedPermissions;
